import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  DataTable,
  NoteTooltipTableCell,
  PartNumber
} from "MODULES/shared/components";
import { QUOTE_TYPES_ABBREV } from "MODULES/RepairQuotes/constants";
import { dollars } from "LIB/formatters/currency";
import { CONDITION_TYPES } from "MODULES/Receiving/constants";
import ClipboardCopy from "MODULES/shared/components/ClipboardCopy";

export class LineItemsTable extends Component {
  static propTypes = {
    loading: PropTypes.bool.isRequired
  };

  renderRow = (lineItem, i) => (
    <tr key={lineItem.id} className="clickable">
      <td>
        <div style={{ whiteSpace: "nowrap" }}>{i + 1}</div>
      </td>
      <td>
        <div style={{ whiteSpace: "nowrap" }}>
          <PartNumber part={lineItem.part} statsTooltip />
        </div>
      </td>
      <td>
        <ClipboardCopy
          name={lineItem}
          handleClick={() =>
            navigator.clipboard.writeText(lineItem.part.part_number)}
        />
      </td>
      <td>{QUOTE_TYPES_ABBREV[lineItem.quote_type]}</td>
      <td>{lineItem.condition && CONDITION_TYPES[lineItem.condition].label}</td>
      <td className="text-center">{lineItem.quantity}</td>
      <td className="text-right">{dollars(lineItem.cost)}</td>

      <NoteTooltipTableCell note={lineItem.note} />
    </tr>
  );

  render() {
    const { requiredComponents } = this.props;
    return (
      <DataTable.Mini loading={this.props.loading} numbered>
        <DataTable.Head>
          <th />
          <th>Part #</th>
          <th />
          <th>Type</th>
          <th>Cond</th>
          <th className="text-center">Qty Reqd</th>
          <th className="text-right">Cost/Unit</th>
          <th />
        </DataTable.Head>
        <DataTable.Body>
          {requiredComponents.map(this.renderRow)}
        </DataTable.Body>
      </DataTable.Mini>
    );
  }
}

export default LineItemsTable;



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/FormSections/RequiredComponents/Table.jsx